import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { apiFetch } from '../api/client';
import { useClassroom } from '../classroom/api';
import { Toolbar } from '../planner/Toolbar';
import { logoUrl } from '../theme/applyTheme';
import { useTheme, useThemeSync } from '../theme/api';
import { useMe } from './useMe';

/** The toolbar plus the page, shared by every signed-in route. */
export default function AppShell() {
  const { data: me } = useMe();
  useThemeSync();
  const theme = useTheme().data;
  const classroom = useClassroom().data;
  const queryClient = useQueryClient();
  const classroomName = classroom?.name;
  useEffect(() => {
    if (classroomName) document.title = `${classroomName} · Weekplanner`;
  }, [classroomName]);
  const logout = useMutation({
    mutationFn: () => apiFetch('/api/logout', { method: 'POST' }),
    // RequireAuth sees the cleared session and routes back to /login.
    onSuccess: () => queryClient.setQueryData(['me'], null),
  });

  return (
    <>
      <a href="#inhoud" className="skip-link no-print">
        Naar de inhoud
      </a>
      <Toolbar classroomName={classroom?.name ?? 'Weekplanner'} me={me} logoSrc={theme ? logoUrl(theme) : null} onLogout={() => logout.mutate()} />
      <div id="inhoud" tabIndex={-1}>
        <Outlet />
      </div>
    </>
  );
}
